import { render, staticRenderFns } from "./wxalink.vue?vue&type=template&id=54df2d15&scoped=true&"
import script from "./wxalink.vue?vue&type=script&lang=js&"
export * from "./wxalink.vue?vue&type=script&lang=js&"
import style0 from "./wxalink.vue?vue&type=style&index=0&id=54df2d15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54df2d15",
  null
  
)

export default component.exports